mutation ReopenThread($input: ThreadReopenInput!) {
    threadReopen(input: $input) {
        thread {
            id
        }
    }
}
